import { Center, Stack, VStack } from "@chakra-ui/layout";
import React, { useState, memo } from "react";
import { useSession } from "next-auth/client";
import {
  Button, Input, Text, Box, IconButton,
  useDisclosure,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Textarea,
  Link,
  Flex,
  useMediaQuery, Alert, AlertDescription, AlertIcon,
  Badge,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { DownloadIcon } from '@chakra-ui/icons'
import { CSVLink } from 'react-csv';
import { Tooltip } from "@chakra-ui/tooltip";

import Masonry from "./masonry";
import theme from "@chakra-ui/theme";
import toast from "react-hot-toast";
import * as analytics from "../../utils/analytics";
import { BsCodeSlash } from 'react-icons/bs';
import { BiCopy, BiRefresh } from "react-icons/bi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { TweetContext } from "../../context/tweetContext";
import { CloseIcon } from "@chakra-ui/icons";
import { getAccount } from "utils/sessionHelper";
import { RefreshIconComponent } from "components/icons/RefreshIconComponent";
import { layerStyle, textStyle } from "theme/names";

const ShowTypes = ["masonry", "table"] as const;
type ShowType = typeof ShowTypes[number];

function isEqual(prevProps, nextProps) {

  // console.log("isEqual tweets");
  // console.log("isDiff " + (prevProps.tweets != nextProps.tweets));
  // console.log("isDiff " + (prevProps.savedTweet != nextProps.savedTweet));
  // console.log("isDiff " + (prevProps.refresh != nextProps.refresh));
  if (prevProps.tweets != nextProps.tweets
    || prevProps.savedTweet != nextProps.savedTweet
    || prevProps.refresh != nextProps.refresh
    // || true
  ) {
    // console.log("tweets not equal");
    return false;
  }
  return true;
}

const headers = [
  { label: "ID", key: "id" },
  { label: "Date", key: "created_at" },
  { label: "Handle", key: "twUserName" },
  { label: "User followers", key: "user.followers_count" },
  { label: "# retweets", key: "retweet_count" },
  { label: "# likes", key: "favorite_count" },
  // { label: "Score", key: "score" },
  { label: "Text", key: "full_text" },
];

//@ts-ignore
const Tweets = ({ sendRequest = undefined, data = undefined, setData = undefined, tweets, savedTweet,
  disableBlur = false,
  disableBookmarkButton = false,
  disableHideButton = false,
  refresher, refresh,
  disableSaveCsv = false,
  mode = "copy",
  disableRequest = false,
  disableEditTweet = false,
  disableEmbed = false,
  embedData = null,
  header = "" as any,
  disableTryAgain = true,
  disableRefresh = true,
  refreshButton = undefined,
  filters = [],
  handleRemoveFilter = undefined,
  disableDescriptionWarning = true,
  disableTweetCount = true,
  addSubscribeTile = false,
  ...rest
  // isSelectable=false,
  // disableCopy=false,
  // disableCheckmark=true,
  // disableSubMenu=false,
  // toggleSelection=undefined,
  // forceSelectedTweet=undefined,
}) => {
  const [showAs, setShowAs] = useState<ShowType>("masonry");
  const [session, loading] = useSession();
  const [selectedTweet, setSelectedTweet] = React.useState(null);
  const [usedTweets, setUsedTweets] = React.useState([]);
  const csvLink = React.useRef(null);
  const { isOpen: isOpenEmbed, onOpen: onOpenEmbed, onClose: onCloseEmbed } = useDisclosure();
  const [isTooSmall] = useMediaQuery("(max-width: 800px)");
  const tweetContext: any = React.useContext(TweetContext);

  // console.log("render tweets");

  const removeTweet = (tw) => {
    if (data && setData != null) {
      let match = tweets.find(x => x.id_str === tw.id_str);
      if (match) {
        tweets.splice(tweets.indexOf(match), 1);
        //@ts-ignore
        setData({ ...data, tweets: tweets });
        refresher({});
      }
    }
  }

  React.useEffect(() => {

    setUsedTweets(session?.user?.data?.subscription?.isSubscribed
      || disableBlur
      || session?.user?.data?.remainingFreeSearch // > 0
      ? tweets
      : tweets.map((v, i) =>
        i >= 4
          ? {
            ...v,
            isBlurred: true,
            full_text:
              "Surprise code goes here!Surprise code goes here!Surprise code goes here!",
          }
          : { ...v }
      ));
  }, [session?.user?.data?.subscription?.isSubscribed]);

  React.useEffect(() => {
    if (addSubscribeTile) {
      let tile = { type: "subscribe" };
      tweets.splice(5, 0, tile);
    }
  }, [tweets]);

  var embedCode;
  if (embedData && !disableEmbed) {
    embedCode = `<div id="tweethunter"></div>
<script type='text/javascript' charset='utf-8'>     
  var iframe = document.createElement('iframe');document.getElementById('tweethunter').appendChild(iframe);
  iframe.id='iframe';iframe.src='https://tweethunter.io/embed?id=${
      //@ts-ignore
      embedData.id + (embedData.idList !== undefined ? "&idList=" + embedData.idList + "&list=" + encodeURIComponent(session?.user?.data?.lists.find(x => x.id === embedData.idList)?.name) + "&handle=" + session?.user?.data?.twUserName : "")}';iframe.width='100%';iframe.height='2000px';iframe.frameBorder='0';iframe.scrolling='no';iframe.style='overflow: hidden;';
  var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
  var eventer = window[eventMethod];
  var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
  eventer(messageEvent, function(e) {
    if (isNaN(e.data)) return;
    document.getElementById('iframe').style.height = e.data + 'px';
  }, false);
</script>`;
  }

  return (
    <Flex justifyContent="center" w="100%">
      {/* <Stack pb={10} pl={isTooSmall || !tweetContext.isOpen ? "0" : "100px"} pr={isTooSmall || !tweetContext.isOpen ? "0" : "100px"} w="100%" maxW="1000px"> */}
      <Stack pb={10} w="100%" maxW="1000px">
        {
          !disableDescriptionWarning && !getAccount(session).description && (
            <Flex w="100%" justifyContent="center">
              {/* <Badge
                  py="2px"
                  px="7px"
                  fontSize="sm"
                  borderRadius="6"
                  fontWeight="500"
                  colorScheme="orange"
                  variant={"secondary"}
                  textTransform="none"
                  whiteSpace="normal"
                > */}
              <Alert status="info">
                <AlertIcon />
                <AlertDescription p="2">
                  <Link href="/onboarding">
                    Please provide more information so we can improve these results. Update settings here.
                  </Link>
                </AlertDescription>
              </Alert>
              {/* </Badge> */}
            </Flex>
          )
        }
        <Flex flexDir={isTooSmall ? "column" : "row"} justifyContent={"space-between"} alignItems={isTooSmall ? "flex-end" : "center"}>
          <Flex>
            {!!header && (
              <Text mb={isTooSmall ? 2 : 0} fontSize="xs"
                textStyle={textStyle["body.medium.light"]}
              >{header}</Text>
            )}
          </Flex>
          <HStack display="flex" justifyContent="flex-end" pr={1} spacing={2}>
            {
              !disableTweetCount && (
                <Box mr={2}>
                  <Text
                    // fontSize="xs"
                    textStyle={textStyle["body.medium.light"]}
                  >
                    {/* <i> */}
                    {tweets?.length + " tweet" + (tweets?.length > 1 ? "s" : "")}
                    {/* </i> */}
                  </Text>
                </Box>
              )
            }
            {
              !disableEmbed && (
                <Tooltip label={session?.user?.uid ? "Embed tweets on your website" : "You need to be signed up to export CSV"} >
                  <Box>
                    <Button
                      variant="secondary"
                      isDisabled={!session?.user?.uid} leftIcon={<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.28125 4.25C5.5625 4.5625 5.5625 5.03125 5.25 5.3125L1.84375 8.5L5.21875 11.7188C5.53125 12 5.53125 12.4688 5.25 12.7812C5.09375 12.9375 4.90625 13 4.71875 13C4.5625 13 4.375 12.9375 4.21875 12.8125L0.21875 9.0625C0.0625 8.90625 0 8.71875 0 8.5C0 8.3125 0.0625 8.09375 0.21875 7.96875L4.21875 4.21875C4.53125 3.9375 5 3.9375 5.28125 4.25ZM12.1875 0.53125C12.5938 0.65625 12.8125 1.0625 12.7188 1.46875L8.71875 15.9688C8.625 16.3125 8.3125 16.5 8 16.5C7.90625 16.5 7.84375 16.5 7.78125 16.5C7.375 16.375 7.15625 15.9688 7.25 15.5625L11.25 1.0625C11.375 0.65625 11.7812 0.4375 12.1875 0.53125ZM19.75 7.96875C19.9062 8.09375 20 8.3125 20 8.5C20 8.71875 19.9062 8.90625 19.75 9.0625L15.75 12.8125C15.5938 12.9375 15.4062 13 15.25 13C15.0312 13 14.8438 12.9375 14.6875 12.7812C14.4062 12.4688 14.4062 12 14.7188 11.7188L18.125 8.5L14.7188 5.3125C14.4062 5.03125 14.4062 4.5625 14.6875 4.25C14.9688 3.9375 15.4375 3.9375 15.75 4.21875L19.75 7.96875Z" fill="currentColor" />
                      </svg>
                      } onClick={() => { onOpenEmbed(); }}>
                      Embed
                    </Button>
                  </Box>
                </Tooltip>
              )
            }
            {
              !disableSaveCsv && (
                <Tooltip label={session?.user?.uid ? "Export tweets as CSV" : "You need to be signed up to export CSV"}>
                  <Box>
                    <Button
                      variant="secondary"
                      // m={0}
                      // size="sm" 
                      isDisabled={!session?.user?.uid}
                      leftIcon={<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 10C15.0938 10 16 10.9062 16 12V14.5C16 15.625 15.0938 16.5 14 16.5H2C0.875 16.5 0 15.625 0 14.5V12C0 10.9062 0.875 10 2 10H3.65625L5.15625 11.5H2C1.71875 11.5 1.5 11.75 1.5 12V14.5C1.5 14.7812 1.71875 15 2 15H14C14.25 15 14.5 14.7812 14.5 14.5V12C14.5 11.75 14.25 11.5 14 11.5H10.8125L12.3125 10H14ZM13.5 13.25C13.5 13.6875 13.1562 14 12.75 14C12.3125 14 12 13.6875 12 13.25C12 12.8438 12.3125 12.5 12.75 12.5C13.1562 12.5 13.5 12.8438 13.5 13.25ZM7.46875 12.0312L3.1875 7.78125C2.875 7.5 2.875 7.03125 3.1875 6.71875C3.46875 6.4375 3.9375 6.4375 4.25 6.71875L7.25 9.71875V1.25C7.25 0.84375 7.5625 0.5 8 0.5C8.40625 0.5 8.75 0.84375 8.75 1.25V9.71875L11.7188 6.75C12 6.4375 12.4688 6.4375 12.75 6.75C13.0625 7.03125 13.0625 7.5 12.75 7.78125L8.5 12.0312C8.375 12.1875 8.1875 12.25 8 12.25C7.78125 12.25 7.59375 12.1875 7.46875 12.0312Z" fill="currentColor" />
                      </svg>
                      }
                    >
                      {
                        session?.user?.uid ? (
                          <CSVLink
                            data={tweets}
                            headers={headers}
                            filename={"tweets.csv"}
                            className="hidden"
                            ref={csvLink}
                            target="_blank"
                          >
                            Export CSV
                          </CSVLink>
                        ) : (
                          "Export CSV"
                        )
                      }
                    </Button>
                  </Box>
                </Tooltip>
              )
            }
            {
              !disableRefresh && (
                <Box>
                  <Button
                    mb={4}
                    // size="sm" 
                    isDisabled={!session?.user?.uid}
                    leftIcon={<RefreshIconComponent width={12} />}
                    // leftIcon={<BiRefresh  />} 
                    variant="primary"
                    onClick={() => {
                      //@ts-ignore
                      sendRequest && sendRequest(session);
                    }}
                  >
                    Refresh
                  </Button>
                </Box>
              )
            }
          </HStack>
        </Flex>

        {
          filters?.length > 0 && (
            <Center>
              <Wrap justify="center" pb="6" spacing="3" maxW="550px">
                {
                  filters.map((filter, index) => (
                    <WrapItem key={"filter" + index}>
                      <Button
                        variant="filter"
                        // layerStyle={layerStyle.bgBorderGray}
                        // textStyle={textStyle["body.medium.standard"]}
                        // @ts-ignore
                        key={filter.id}
                      // display="flex"
                      // alignItems="center"
                      // py="2px"
                      // px="7px"
                      // borderRadius="8"
                      // fontWeight="500"
                      >
                        {/* 
                        // @ts-ignore */}
                        {filter.name}{" "}
                        {handleRemoveFilter && (
                          <CloseIcon
                            marginLeft="2"
                            width="0.75em"
                            height="0.75em"
                            // @ts-ignore
                            onClick={() => handleRemoveFilter(filter.id)}
                            cursor="pointer"
                          />
                        )}
                      </Button>
                    </WrapItem>
                  ))
                }
              </Wrap>
            </Center>

          )
        }

        <Masonry
          savedTweet={savedTweet}
          //@ts-ignore
          tweets={usedTweets}
          disableBookmarkButton={disableBookmarkButton}
          disableHideButton={disableHideButton}
          refresher={refresher}
          removeTweet={removeTweet}
          mode={mode}
          setSelectedTweet={setSelectedTweet}
          disableRequest={disableRequest}
          disableEditTweet={disableEditTweet}
          {...rest}
        // disableCopy={disableCopy}
        // disableSubMenu={disableSubMenu}
        // disableCheckmark={disableCheckmark}
        // isSelectable={isSelectable}
        // forceSelectedTweet={forceSelectedTweet}
        // //@ts-ignore
        // toggleSelection={toggleSelection}
        />
        {
          tweets?.length >= 50 && !disableTryAgain && (

            <VStack
              as="form"
            // onSubmit={(e) => {
            //   e.preventDefault();
            //   //@ts-ignore
            //   sendRequest(session);
            // }}
            >
              {/* <Button maxW={150} type="submit" mt={10} >
                Search Again
              </Button> */}
              <Text
                // color={theme.colors.gray[400]}
                fontSize="sm"
                textAlign="center"
                mt={10}
                pb={50}
                textStyle={textStyle["body.medium.light"]}

              >
                We provide different results at each request, try launching it again
              </Text>
            </VStack>
          )
        }
        {
          !disableEmbed && embedData && (
            <Modal isOpen={isOpenEmbed} onClose={onCloseEmbed} size="lg">
              <ModalOverlay />
              <ModalContent>
                <ModalHeader>Embed your collection</ModalHeader>
                <ModalCloseButton />
                <ModalBody  >
                  <Box>
                    <Text
                      textStyle={textStyle["body.medium.light"]}
                    >
                      Include this code in your website where you want your collection to be embedded.
                    </Text>
                    <Textarea
                      mt={5}
                      mb={5}
                      height="400px"
                      isDisabled
                      value={embedCode}
                    />
                    <CopyToClipboard
                      text={embedCode}
                      onCopy={() => {
                        //@ts-ignore
                        analytics.log("hit_copy_embed", { ...embedData });
                        toast.success("Tweet copied to clipboard", {
                          style: {
                            background: "gray.600",
                            color: "#222",
                          },
                        });
                      }}
                    >
                      <IconButton
                        position="absolute"
                        right="40px"
                        bottom="140px"
                        aria-label="copy-embed"
                        icon={<BiCopy fontSize="26px" />}
                        variant="tertiary"
                        color="gray.600"
                      />
                    </CopyToClipboard>
                    <Text
                      textStyle={textStyle["body.medium.light"]}
                    >
                      Struggle with the integration?
                    </Text>
                    <Text mb={5}
                      textStyle={textStyle["body.medium.light"]}
                    >
                      Reach out to <Link href="https://x.com/patxol" target="_blank">@patxol</Link>
                    </Text>
                  </Box>
                </ModalBody>
              </ModalContent>
            </Modal>
          )
        }
      </Stack>
    </Flex>
  );
};

export default memo(Tweets, isEqual);
